exports.wrapRootElement = require('./libs/wrapRootElement').default;
